import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Fine from './fine.jsx';

export default class ThisDriversArchivedFines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/fines',
      fineAccountId: props.fineAccountId || null,
    };
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/fines/'+
      this.state.fineAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(finesJson) {
      that.setState({
        fines: finesJson,
        isLoading: false
      });
    });
  }

  render() {
    var Fines = [];

    if (this.state.fines && this.state.fines.length > 0) {
      this.state.fines.forEach(function(i) {
          Fines.push(<Fine key={'fine-'+i.id} data={i} />);
        });
    }
    return (
        <div>
            <div className="row fines-table-header">
                <div className="col-md-3">
                    description
                </div>
                <div className="col-md-3">
                    reference
                </div>
                <div className="col-md-2">
                    amounts
                </div>
                <div className="col-md-2">
                    frequency
                </div>
                <div className="col-md-2">
                    details
                </div>
            </div>
            {Fines}
        </div>
    );
  }
}
